export const ACCOUNT_PRIVACY_PATH = "/account/privacy";
export const ACCOUNT_DELETION_CONFIRMATION_PATH =
  "/account/privacy/delete-confirmation";
export const USER_DATA_EXPORT_QUERY_PARAM = "dataExport";

const USER_DATA_EXPORT_ID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/iu;
const LOCAL_PARSE_ORIGIN = "https://gameplaysync.local";

export const normalizeUserDataExportId = (value) => {
  if (typeof value !== "string") {
    return null;
  }

  const normalized = value.trim().toLowerCase();
  return USER_DATA_EXPORT_ID_PATTERN.test(normalized) ? normalized : null;
};

const parseLocationLike = (value) => {
  if (typeof value === "string") {
    const normalized = value.trim();
    if (!normalized.startsWith("/") || normalized.startsWith("//")) {
      return null;
    }

    try {
      const parsed = new URL(normalized, `${LOCAL_PARSE_ORIGIN}/`);
      if (parsed.origin !== LOCAL_PARSE_ORIGIN) {
        return null;
      }
      return {
        pathname: parsed.pathname,
        search: parsed.search,
        hash: parsed.hash,
      };
    } catch {
      return null;
    }
  }

  if (!value || typeof value !== "object" || typeof value.pathname !== "string") {
    return null;
  }

  const search = value.search == null ? "" : String(value.search);
  const hash = value.hash == null ? "" : String(value.hash);
  if ((search && !search.startsWith("?")) || (hash && !hash.startsWith("#"))) {
    return null;
  }

  return {
    pathname: value.pathname.trim(),
    search,
    hash,
  };
};

export const buildUserDataExportAccountPath = (exportId) => {
  const normalizedId = normalizeUserDataExportId(exportId);
  if (!normalizedId) {
    return null;
  }

  const searchParams = new URLSearchParams({
    [USER_DATA_EXPORT_QUERY_PARAM]: normalizedId,
  });
  return `${ACCOUNT_PRIVACY_PATH}?${searchParams.toString()}`;
};

export const normalizeUserDataExportAccountPath = (value) => {
  const parsed = parseLocationLike(value);
  if (
    !parsed ||
    parsed.pathname !== ACCOUNT_PRIVACY_PATH ||
    parsed.hash
  ) {
    return null;
  }

  if (!parsed.search) {
    return ACCOUNT_PRIVACY_PATH;
  }

  const searchParams = new URLSearchParams(parsed.search);
  const keys = Array.from(searchParams.keys());
  const ids = searchParams.getAll(USER_DATA_EXPORT_QUERY_PARAM);
  if (
    keys.length !== 1 ||
    keys[0] !== USER_DATA_EXPORT_QUERY_PARAM ||
    ids.length !== 1
  ) {
    return null;
  }

  return buildUserDataExportAccountPath(ids[0]);
};

export const normalizeAccountPrivacyAuthDestination = (value) => {
  const parsed = parseLocationLike(value);
  if (
    parsed?.pathname === ACCOUNT_DELETION_CONFIRMATION_PATH &&
    !parsed.search &&
    !parsed.hash
  ) {
    return ACCOUNT_DELETION_CONFIRMATION_PATH;
  }

  return normalizeUserDataExportAccountPath(value);
};

export const getUserDataExportIdFromAccountPath = (value) => {
  const normalizedPath = normalizeUserDataExportAccountPath(value);
  if (!normalizedPath || normalizedPath === ACCOUNT_PRIVACY_PATH) {
    return null;
  }

  return normalizeUserDataExportId(
    new URLSearchParams(normalizedPath.split("?", 2)[1]).get(
      USER_DATA_EXPORT_QUERY_PARAM,
    ),
  );
};

export default {
  ACCOUNT_PRIVACY_PATH,
  ACCOUNT_DELETION_CONFIRMATION_PATH,
  USER_DATA_EXPORT_QUERY_PARAM,
  buildUserDataExportAccountPath,
  getUserDataExportIdFromAccountPath,
  normalizeAccountPrivacyAuthDestination,
  normalizeUserDataExportAccountPath,
  normalizeUserDataExportId,
};
